export async function loadEquipmentDecoder() {
  return (await import("jsqr")).default;
}
